import styled from "styled-components";
import { CreateButton } from "../../Header/Header.styled";

export const InfoWrapper = styled.div`
  background: ${(props) => props.theme.bgColor};
  box-shadow: 1px 6px 20px rgba(0, 0, 0, 0.22);
  border-radius: 10px;
  padding: 20px 25px;
`;

export const InfoHeader = styled.div`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  & h2 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 32px;
    color: ${(props) => props.theme.textColor};
    margin-bottom: 10px;
    @media (max-width: 768.98px) {
      font-size: 28px;
    }
  }
  > div {
    position: relative;
  }
  > :last-child {
    display: flex;
  }
  & h6 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 126.2%;
    color: ${(props) => props.theme.subtitleColor};
    & span {
      color: ${(props) => props.theme.textColor};
    }
  }
`;

export const InfoText = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 126.2%;
  color: ${(props) => props.theme.textColor};
  margin-top: 15px;
  @media (max-width: 768.98px) {
    font-size: 16px;
  }
  & .read-more-button {
    margin: 10px 0;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: #0088cc;
    cursor: pointer;
  }
`;

export const InfoPrice = styled.div`
  padding: 10px 0;
  & h5 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    margin: 10px 0;
  }
  & h3 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    display: flex;
    & img {
      margin-left: 10px;
      width: 26px;
    }
  }
  & span {
    display: flex;
    align-items: center;
    margin: 5px 0;
    font-family: "Inter";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 126.2%;
    color: #adadad;
    & svg {
      margin-left: 5px;
      cursor: pointer;
    }
  }
`;

export const BuyButton = styled(CreateButton)`
  width: 100%;
  margin: 30px 0 25px;
  height: 50px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 126.2%;
`;

export const InfoLinks = styled.div`
  display: flex;
  border-top: 1px solid ${(props) => props.theme.borderColor};
  align-items: center;
  justify-content: space-between;
  padding: 30px 0;
  @media (max-width: 768.98px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
  }
  & a {
    display: flex;
    @media (max-width: 768.98px) {
      margin-top: 20px;
    }
    & img {
      border-radius: 50%;
      margin-right: 5px;
      width: 60px;
      height: 60px;
      object-fit: 1/1;
    }
    & div {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      & h6 {
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 20px;
        color: ${(props) => props.theme.textColor};
      }
      & span {
        font-family: "Inter";
        font-style: normal;
        font-weight: 200;
        font-size: 18px;
        line-height: 18px;
        color: ${(props) => props.theme.textColor};
      }
    }
  }
`;

export const DropdownButton = styled.div`
  width: 45px;
  height: 45px;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 50%;
  cursor: pointer;
  color: ${(props) => props.theme.textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  line-height: 0;
  & svg {
    path {
      stroke: ${(props) => props.theme.textColor};
    }
  }
`;

export const Like = styled.div`
  width: 45px;
  height: 45px;
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 50%;
  cursor: pointer;
  color: ${(props) => props.theme.textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  line-height: 0;
  margin: 0 10px;
  & svg {
    path {
      fill: ${(props) => (props.like ? "#FF0000" : props.theme.textColor)};
    }
  }
`;

export const SingleNftDropdown = styled.div`
  position: absolute;
  background: ${(props) => props.theme.body};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 16px;
  padding: 10px;
  top: 50px;
  right: 0;
  & button {
    border: none;
    background: none;
    cursor: pointer;
    display: flex;
    white-space: nowrap;
    align-items: center;
    padding: 8px 15px;
    transition: 0.2s;
    border-radius: 5px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 126.2%;
    width: 100%;
    color: ${(props) => props.theme.textColor};
    &:hover {
      background: ${(props) => props.theme.hover};
    }
    & svg {
      margin-right: 15px;
      & path {
        stroke: ${(props) => props.theme.textColor};
      }
    }
  }
`;
